<template>
	<el-container id="app" direction="vertical" v-loading="loading">
		<Header @showMap="showMap" @showEmotion="showEmotion"></Header>
		<el-container style="height: calc(100% - 48px)">
			<Chat @saveConfig="saveConfig"></Chat>
			<Content ref="content"></Content>
			<Settings @saveConfig="saveConfig"></Settings>
			<modal
				name="map"
				:draggable="this.$store.state.sysInit.draggableFlag"
				:clickToClose="false"
				classes="el-dialog"
				width="700"
				height="500"
				@opened="mapOpen('map')"
			>
				<div class="el-dialog__header">
					<span class="el-dialog__title">
						<!-- キーワード相関MAP -->
						{{ this.$store.state.sysInit.html_const.cons_243_relation_map }}
					</span>
					<span class="demonstration">{{
						this.$store.state.sysInit.html_const.cons_244_max_nodes
					}}</span>
					<el-slider
						:min="50"
						:max="90"
						v-model="$store.state.sysInit.keywordRate"
						:step="10"
						show-stops
						:marks="marks"
					>
					</el-slider>

					<!-- 最大ノード数 -->
					<!-- <span style="margin-left:360px">
            {{this.$store.state.sysInit.html_const.cons_244_max_nodes}}
          </span>
          <el-input size="mini" v-model="$store.state.sysInit.keywordRate" style="width:80px" @keyup.enter.native="savekeyMapRate"></el-input> -->
					<button
						type="button"
						aria-label="Close"
						class="el-dialog__headerbtn header-savebtn"
						@click="savekeyMapRate()"
					>
						<i class="el-icon el-icon-save"></i>
					</button>

					<button
						type="button"
						aria-label="Close"
						class="el-dialog__headerbtn header-minbtn"
						@click="minMap()"
					>
						<i class="el-dialog__close el-icon el-icon-minus"></i>
					</button>
					<button
						type="button"
						aria-label="Close"
						class="el-dialog__headerbtn"
						@click="hideMap('map')"
					>
						<i class="el-dialog__close el-icon el-icon-close"></i>
					</button>
				</div>
				<div class="el-dialog__body">
					<div id="map" style="width: 100%; height: 100%"></div>
				</div>
			</modal>

			<modal
				name="emotion"
				:draggable="this.$store.state.sysInit.draggableFlag"
				:clickToClose="false"
				classes="el-dialog"
				width="700"
				height="500"
				@opened="mapOpen('emotion')"
			>
				<div class="el-dialog__header">
					<span class="el-dialog__title">
						<!-- キーワード相関MAP -->
						<!-- {{this.$store.state.sysInit.html_const.cons_243_relation_map}}   -->
						センチメント分析モニター
					</span>
					<el-button size="mini" style="margin-left: 300px">
						SVヘルプ依頼
					</el-button>
					<button
						type="button"
						aria-label="Close"
						class="el-dialog__headerbtn header-minbtn"
						@click="minEmotion()"
					>
						<i class="el-dialog__close el-icon el-icon-minus"></i>
					</button>
					<button
						type="button"
						aria-label="Close"
						class="el-dialog__headerbtn"
						@click="hideEmotion('emotion')"
					>
						<i class="el-dialog__close el-icon el-icon-close"></i>
					</button>
				</div>
				<div class="el-dialog__body">
					<p style="position: absolute; top: 65px; left: 566px">
						<el-button type="success" class="rate is-circle" icon="good">
						</el-button>
						<el-button type="danger" class="rate is-circle" icon="bad">
						</el-button>
					</p>
					<div id="emotion" style="width: 100%; height: 90%"></div>
				</div>
			</modal>

			<modal
				name="minmap"
				:draggable="this.$store.state.sysInit.draggableFlag"
				:clickToClose="false"
				classes="el-dialog"
				width="150"
				height="150"
				:pivotX="0.99"
				:pivotY="0.98"
				@opened="mapOpen('minmap')"
			>
				<div class="el-dialog__body min-map" @click="MaxMap()">
					<div id="minmap" style="width: 150px; height: 150px"></div>
				</div>
			</modal>
			<modal
				name="minemotion"
				:draggable="this.$store.state.sysInit.draggableFlag"
				:clickToClose="false"
				classes="el-dialog"
				width="150"
				height="150"
				:pivotX="0.99"
				:pivotY="0.98"
				@opened="mapOpen('minemotion')"
			>
				<div class="el-dialog__body min-map" @click="MaxEmotion()">
					<div id="minemotion" style="width: 150px; height: 150px"></div>
				</div>
			</modal>
		</el-container>
		<el-drawer :with-header="false" :modal="false" :show-close="false" :size="350" :visible="showPhone" @close="$store.dispatch('phone/setShowPhone', false)">
			<Phone></Phone>
		</el-drawer>
		<el-dialog
			title="確認"
			:visible.sync="$store.state.phone.showStopMonitoringConfirmDialog"
			width="30%"
		>
			<span>ダッシュボードでのモニタリングを停止してもよろしいですか？</span>
			<span slot="footer">
				<el-button class="is-red" @click="handleStopMonitoringConfirmOkClick">
					{{this.$store.state.sysInit.html_const.cons_251_logout_confirm_ok}}
				</el-button>
				<el-button class="is-blue" @click="handleStopMonitoringConfirmCancelClick">
					{{this.$store.state.sysInit.html_const.cons_252_logout_confirm_cancel}}
				</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Settings from "../components/Settings.vue";
import Chat from "@/components/Chat.vue";
import Content from "@/components/Content.vue";
import Phone from "@/components/phone/Phone.vue";

export default {
	components: {
		Header,
		Footer,
		Chat,
		Content,
		Settings,
		Phone,
	},
	props: {},
	data() {
		return {
			marks: {
				50: "50%",
				60: "60%",
				70: "70%",
				80: "80%",
				90: "90%",
			},
			sipFirstConnect: true,
			// draggableFlag:this.$store.state.sysInit.draggableFlag
		};
	},
	watch: {
		sipConnect(newValue) {
			if (newValue) {
				this.connectSip();
			} else {
				this.disConnectSip();
			}
		},
	},
	computed: {
		loading() {
			return this.$store.state.discovery.loading;
		},
		sipConnect() {
			if (
				this.$store.state.sysInit.sip_domain != "" &&
				this.$store.state.sysInit.tel_num != "" &&
				this.$store.state.sysInit.personalSingleMode ==
					"NEXMO_ASTERISK_PBX_MODE"
			) {
				return true;
			} else {
				return false;
			}
		},
		showPhone() {
			return this.$store.state.phone.showPhone;
		},
	},
	methods: {
		saveConfig() {
			this.$refs.content.resetTab();
		},
		mapOpen(type) {
			console.log("mapOpen");
			this.$store.dispatch("echart/echartInit", {
				type,
				data: this.$store.state.discovery.mapData,
			});
		},
		showMap(type) {
			// this.$modal.show('map');
			console.log("showMap");
			if (type == "minmap") {
				this.$modal.show("minmap");
			} else {
				this.$modal.show("map");
			}
		},
		hideMap(type) {
			console.log("hideMap");
			this.$store.commit("echart/changeMapFlag", false);
			this.$modal.hide(type);
		},
		minMap() {
			console.log("minmap");
			this.$modal.hide("map");
			this.$modal.show("minmap");
		},
		MaxMap() {
			console.log("maxmap");
			this.$modal.hide("minmap");
			this.$modal.show("map");
		},
		showEmotion(type) {
			// this.$modal.show('emotion');
			console.log("showEmotion");
			if (type == "minemotion") {
				this.$modal.show("minemotion");
			} else {
				this.$modal.show("emotion");
			}
		},
		hideEmotion(type) {
			console.log("hideEmotion");
			this.$store.commit("echart/changeEmotionFlag", false);
			this.$modal.hide(type);
		},
		minEmotion() {
			console.log("minEmotion");
			this.$modal.hide("emotion");
			this.$modal.show("minemotion");
		},
		MaxEmotion() {
			console.log("MaxEmotion");
			this.$modal.hide("minemotion");
			this.$modal.show("emotion");
		},
		savekeyMapRate() {
			console.log(this.$store.state.sysInit.keywordRate);
			console.log("save button start");
			const keywordRate = this.$store.state.sysInit.keywordRate;
			let params = {
				keywordRate: keywordRate,
				keyword: this.$store.state.sysInit.currentKeyword,
			};
			this.$store.dispatch("echart/updatePersonalConfig", params);
			this.$store.commit("sysInit/changeKeywordRate", keywordRate);
			console.log("save button end");
		},
		connectSip() {
			console.log("connectSip.....");
			let sipConfig = {
				SipUsername: this.$store.state.sysInit.tel_num,
				SipDomain: this.$store.state.sysInit.sip_domain,
				SipPassword: this.$store.state.sysInit.sip_pw,
				wssServer: this.$store.state.sysInit.sip_wss_server,
				WebSocketPort: this.$store.state.sysInit.sip_websocket_port,
				ContactUserName: "",
				profileName: this.$store.state.sysInit.tel_num,
				ServerPath: this.$store.state.sysInit.sip_server_path
			};
			if (this.sipFirstConnect) {
				this.$SIP.initPhone(sipConfig);
				this.$SIP.ToggleDoNoDisturb(true)
				this.sipFirstConnect = false;
			} else {
				this.$SIP.RefreshRegistration();
			}
			// this.$SIP.initSipConfig(sipConfig)
			// this.$SIP.CreateUserAgent(sipConfig)
		},
		disConnectSip() {
			this.$SIP.Unregister();
		},
		handleStopMonitoringConfirmOkClick() {
			this.$store.commit('phone/updateShowStopMonitoringConfirmDialog', {showStopMonitoringConfirmDialog: false, stopMonitoring: true})
		},
		handleStopMonitoringConfirmCancelClick() {
			this.$store.commit('phone/updateShowStopMonitoringConfirmDialog', {showStopMonitoringConfirmDialog: false});
			this.$store.commit('phone/updateStopMonitoringTrigger', '');
			this.$store.commit('phone/updateLineNumber', '');
		},
	},
	created() {
		// console.log('sip ===> ', this.$SIP);
		// let sipConfig = {
		//   SipUsername: '01003',
		//   SipDomain: '128.168.131.138',
		//   SipPassword: "aicc@ibm.com",
		//   wssServer: "128.168.131.138",
		//   WebSocketPort: "8089",
		//   ContactUserName: "Hong Wang",
		//   profileName: "01003",
		//   ServerPath: '/ws'
		// }
		// this.$SIP.initSipConfig(sipConfig)
		// console.log('sip init config after ===> ', this.$SIP);
		// this.$SIP.CreateUserAgent()

		console.log("this.$route.query", this.$route.query);
		this.$store.dispatch("sysInit/fetchPersonalAndSingleModeConfig"),
			// this.$store.dispatch("sysInit/fetchPersonalConfig"),
			// this.$store.dispatch("sysInit/fetchSingleMode"),
			this.$store.dispatch("discovery/fetchCollections"),
			this.$store.dispatch("sysInit/fetchHtmlConst"),
			// this.$store.dispatch("sysInit/fetchLogos");
			this.$store.dispatch("sysInit/fetchAllCustomerName");
		this.$store.dispatch("sysInit/manualChatFetchSuggestions");
		this.$store.dispatch("sysInit/getCurrentUserCount");
		this.$store.dispatch("sysInit/getEmpathyMatchingToken");

		this.$store.dispatch("sysInit/getAllInnerChatUserList");

		// window.location('http://localhost:8080');

		// let login_id = this.$route.query.login_id;
		// let token = this.$route.query.token;
		// let user_id = this.$route.query.user_id;
		// let app_link = this.$route.query.app_link;
		// console.log('token',token);
		// if (login_id && token && user_id && app_link) {
		//   sessionStorage.setItem("login_id", login_id);
		//   sessionStorage.setItem("token", token);
		//   sessionStorage.setItem("user_id", user_id);
		//   sessionStorage.setItem("app_link", app_link);
		// }
		// if(this.$route.query.token){
		//     window.location = app_link;
		//   }
	},
	mounted() {
		// console.log("this.draggableFlag",this.draggableFlag);
		// console.log('sip ===> ', this.$SIP);
		// this.connectSip()
	},
};
</script>

<style lang="scss" scoped>
.is-red {
  background-color: #ffd7da;
  border-color: #ffa4ab;
  color: #000;
  margin-top: 7px;
  min-width: 8em;
  min-height: 45px;
}
.is-blue {
  margin-top: 7px;
  min-width: 8em;
  min-height: 45px;
}
</style>
